'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJoinKey = getJoinKey;
exports.getUniqueKey = getUniqueKey;
exports.splitKey = splitKey;
/**
 * Get the joined key with _
 * @param  {Array[String]} args
 * @return {String}
 */
function getJoinKey() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.join('_');
}

/**
 * Get a unique key
 * @return {String} like 'xermrxe2'
 */
var ID = new Date().getTime();
function getUniqueKey() {
  return (ID++).toString(36);
}

var RE_KEY_PATH = /([^\/]*)(?:\/(.*))?/;
function splitKey(key) {
  return RE_KEY_PATH.exec(key);
}